<template>
  <div class="compliance-questionnaire">
    <fieldset class="info-group">
      <legend>{{ $t("kyc.section.complianceQuestionnaire") }}</legend>
    </fieldset>
    <fieldset :disabled="kycStatus=== 'submitted'?true:false">
    <p class="questionnaire-s">{{ $t("kyc.q1SanctionsList") }}</p>
    <div class="info-group">
      <div class="form-group with-icon-right"
           :class="{'has-error': question1Status, 'valid': question1Status}">
        <div class="input-group">
          <vuestic-kyc-select name="question1"
                              data-vv-as="question1"
                              v-validate="'required'"
                              required
                              :label="$t('ticket.select')"
                              v-model="complianceQuestionnaire.question1"
                              option-key="value"
                              :options="commonOptions"
                              ref="myInput"
                              autocomplete="off"
                              @input="(val)=>{question1Status = !val?true:false}"
                              :disabled="kycStatus=== 'submitted'?true:false" />
          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa icon-right input-icon"></i>
          <small v-show="question1Status"
                 class="help text-danger">{{ $t("kyc.theFieldIsRequired") }}</small>
        </div>
      </div>
      <div class="info-group-space"></div>
      <div class="form-group with-icon-right"></div>
    </div>

    <p class="questionnaire-s">
      {{ $t("kyc.q2CountryWideSanctions") }}</p>
    <div class="info-group">
      <div class="form-group with-icon-right"
           :class="{'has-error': question2Status, 'valid': question2Status}">
        <div class="input-group">
          <vuestic-kyc-select name="question2"
                              data-vv-as="question2"
                              v-validate="'required'"
                              required
                              :label="$t('ticket.select')"
                              v-model="complianceQuestionnaire.question2"
                              option-key="value"
                              :options="commonOptions"
                              ref="myInput"
                              autocomplete="off"
                              @input="(val)=>{question2Status = !val?true:false}"
                              :disabled="kycStatus=== 'submitted'?true:false" />
          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa icon-right input-icon"></i>
          <small v-show="question2Status"
                 class="help text-danger">{{ $t("kyc.theFieldIsRequired") }}</small>
        </div>
      </div>
      <div class="info-group-space"></div>
      <div class="form-group with-icon-right"></div>
    </div>

    <p class="questionnaire-s">{{ $t("kyc.q3OwnedBySanctioned") }}</p>
    <div class="info-group">
      <div class="form-group with-icon-right"
           :class="{'has-error': question3Status, 'valid': question3Status}">
        <div class="input-group">
          <vuestic-kyc-select id="question3Input"
                              name="question3"
                              data-vv-as="question3"
                              v-validate="'required'"
                              required
                              :label="$t('ticket.select')"
                              v-model="complianceQuestionnaire.question3"
                              option-key="value"
                              :options="commonOptions"
                              ref="myInput"
                              autocomplete="off"
                              @input="(val)=>{question3Status = !val?true:false}"
                              :disabled="kycStatus=== 'submitted'?true:false" />
          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa icon-right input-icon"></i>
          <small v-show="question3Status"
                 class="help text-danger">{{ $t("kyc.theFieldIsRequired") }}</small>
        </div>
      </div>
      <div class="info-group-space"></div>
      <div class="form-group with-icon-right"></div>
    </div>

    <p class="questionnaire-s">{{ $t("kyc.q4BusinessDealings").replace('{name}', VUE_APP_NAME) }}</p>
    <div class="info-group">
      <div class="form-group with-icon-right"
           :class="{'has-error': question4Status, 'valid': question4Status}">
        <div class="input-group">
          <vuestic-kyc-select id="question4Input"
                              name="question4"
                              data-vv-as="question4"
                              v-validate="'required'"
                              required
                              :label="$t('ticket.select')"
                              v-model="complianceQuestionnaire.question4"
                              option-key="value"
                              :options="commonOptions"
                              ref="myInput"
                              autocomplete="off"
                              @input="(val)=>{question4Status = !val?true:false}"
                              :disabled="kycStatus=== 'submitted'?true:false" />
          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa icon-right input-icon"></i>
          <small v-show="question4Status"
                 class="help text-danger">{{ $t("kyc.theFieldIsRequired") }}</small>
        </div>
      </div>
      <div class="info-group-space"></div>
      <div class="form-group with-icon-right"></div>
    </div>

    <p class="questionnaire-s">{{ $t("kyc.q1SanctionsList") }}</p>
    <div class="info-group">
      <div class="form-group with-icon-right"
           :class="{'has-error': question5Status, 'valid': question5Status}">
        <div class="input-group">
          <vuestic-kyc-select id="question5Input"
                              name="question5"
                              data-vv-as="question5"
                              v-validate="'required'"
                              required
                              :label="$t('ticket.select')"
                              v-model="complianceQuestionnaire.question5"
                              option-key="value"
                              :options="commonOptions"
                              ref="myInput"
                              autocomplete="off"
                              @input="(val)=>{question5Status = !val?true:false}"
                              :disabled="kycStatus=== 'submitted'?true:false" />
          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa icon-right input-icon"></i>
          <small v-show="question5Status"
                 class="help text-danger">{{ $t("kyc.theFieldIsRequired") }}</small>
        </div>
      </div>
      <div class="info-group-space"></div>
      <div class="form-group with-icon-right"></div>
    </div>
    </fieldset>
  </div>

</template>
<script>
import mixin from '../mixins/mixin'
export default {
  mixins: [mixin],
  props: {
    kycStatus: {
      type: String,
      default: '',
    },
    merchantData: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      commonOptions: [
        {
          id: 1,
          value: 'Yes'
        }, {
          id: 0,
          value: 'No'
        }
      ],
      complianceQuestionnaire: {
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
      },
      question1Status: false,
      question2Status: false,
      question3Status: false,
      question4Status: false,
      question5Status: false,
      VUE_APP_NAME: process.env.VUE_APP_NAME
    }
  },
  mounted () {
    let that = this
    if (that.kycStatus === 'firstEdit') {
      that.getMerchantKYCInfo(8, res => {
        that.setComplianceQuestionnaire(res.compliance_questionnaire)
      })
    } else if (that.merchantData.compliance_questionnaire) {
      that.setComplianceQuestionnaire(that.merchantData.compliance_questionnaire)
    } else {}
  },
  computed: {},
  methods: {
    setComplianceQuestionnaire (info) {
      if (!info) return
      this.complianceQuestionnaire.question1 = info.question_a === 0 ? { id: 0, value: 'No' } : { id: 1, value: 'Yes' }
      this.complianceQuestionnaire.question2 = info.question_b === 0 ? { id: 0, value: 'No' } : { id: 1, value: 'Yes' }
      this.complianceQuestionnaire.question3 = info.question_c === 0 ? { id: 0, value: 'No' } : { id: 1, value: 'Yes' }
      this.complianceQuestionnaire.question4 = info.question_d === 0 ? { id: 0, value: 'No' } : { id: 1, value: 'Yes' }
      this.complianceQuestionnaire.question5 = info.question_e === 0 ? { id: 0, value: 'No' } : { id: 1, value: 'Yes' }
    },
    saveComplianceQuestionnaire (cb, callback) {
      if (this.checkComplianceQuestionnaire()) {
        let params = {
          page: 8,
          compliance_questionnaire: {
            question_a: this.complianceQuestionnaire.question1.id,
            question_b: this.complianceQuestionnaire.question2.id,
            question_c: this.complianceQuestionnaire.question3.id,
            question_d: this.complianceQuestionnaire.question4.id,
            question_e: this.complianceQuestionnaire.question5.id,
          },
        }
        cb && cb(params)
      } else {
        callback && callback()
      }
    },
    getComplianceQuestionnaire (cb) {
      let complianceQuestionnaire = new Promise((resolve, reject) => {
        if (this.checkComplianceQuestionnaire()) {
          let params = {
            compliance_questionnaire: {
              question_a: this.complianceQuestionnaire.question1.id,
              question_b: this.complianceQuestionnaire.question2.id,
              question_c: this.complianceQuestionnaire.question3.id,
              question_d: this.complianceQuestionnaire.question4.id,
              question_e: this.complianceQuestionnaire.question5.id,
            },
          }
          resolve(params)
        } else {
          this.$message({
            type: 'warn',
            message: 'Please fill in Compliance Questionnaire'
          })
        }
      })
      return complianceQuestionnaire
    },
    checkComplianceQuestionnaire () {
      let complianceQuestionnaire = ['question1', 'question2', 'question3', 'question4', 'question5']
      let isValidate = complianceQuestionnaire.reduce((result, current) => {
        if (!this.complianceQuestionnaire[current]) {
          this[current + 'Status'] = true
        } else {
          this[current + 'Status'] = false
        }
        return result && !this[current + 'Status']
      }, true)
      return isValidate
    },
  },
}
</script>
<style lang="scss" scoped>
.compliance-questionnaire {
  width: 100%;
  .form-group {
    width: 100%;
  }
  /deep/ .select-form-group {
    margin-bottom: 0;
  }
  /deep/ .vuestic-scrollbar {
    overflow-y: scroll;
  }
  /deep/ .questionnaire-s {
    margin-bottom: 0;
  }
}
</style>
